import { ReactNode } from 'react'

import { styled } from 'styled-components'

import { onSurfaceVariant } from 'core/styles'

import Modal from './Modal'

const Body = styled.div`
  margin: 24px 24px 0;
  color: ${onSurfaceVariant};
`
const Heading = styled.h2`
  margin: 24px 24px 0;

  & + ${Body} {
    margin-top: 12px;
  }
`
const Buttons = styled.div<{ margin?: string }>`
  display: flex;
  flex-direction: row;
  gap: 32px;
  justify-content: flex-end;
  margin: ${(p) => p.margin ?? '40px 24px 24px 24px'};
`

/** @deprecated use ConfirmDialog instead */
function ConfirmModal({
  canClose = false,
  children,
  onClose,
}: {
  canClose?: boolean
  children: ReactNode
  onClose: () => void
}) {
  return (
    <Modal canClose={canClose} onClose={onClose} width={480}>
      {children}
    </Modal>
  )
}

ConfirmModal.Heading = Heading
ConfirmModal.Body = Body
ConfirmModal.Buttons = Buttons

export default ConfirmModal
